<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
// import  from './components/HelloWorld'

export default {
  name: 'App',
  // components: {
  //   // HelloWorld
  // },
  data () {
    return {
      //
    }
  }
}
</script>
